import Typography from '~/shared/components/Typography';
import ArrowRightOnTrayIcon from '~/shared/assets/icons/arrow-right-on-tray.svg';
import Button from '~/shared/components/Buttons';

interface LogoutButtonProps {
  onClick: () => void;
}

export function LogoutButton({ onClick }: LogoutButtonProps): JSX.Element {
  return (
    <Button
      className="w-fit px-2 flex !gap-1 py-1  "
      variant="text"
      // size="sm"
      onClick={onClick}
    >
      <ArrowRightOnTrayIcon className="w-[24px] h-[24px] stroke-primary-900" />
      <Typography
        variant="p3"
        fontWeight={600}
        color="text-primary-900 normal-case font-family-inter"
      >
        Log out
      </Typography>
    </Button>
  );
}
